module.exports = __webpack_public_path__ + "img/saomaCode.8433fc74.jpg";